import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03199fc5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "votes-submit-modal position-fixed top-0 end-0 p-3 m-3"
}
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-hand-thumbs-up-fill" })
], -1))
const _hoisted_5 = { class: "header-content" }
const _hoisted_6 = { class: "modal-title mb-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "Ready to submit", -1))
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "modal-body" }
const _hoisted_12 = {
  key: 0,
  class: "nuts-info"
}
const _hoisted_13 = { class: "nuts-label" }
const _hoisted_14 = {
  ref: "voteCaptchaRef",
  id: "voteCaptcha",
  class: "captcha-container"
}
const _hoisted_15 = { class: "action-buttons" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-rocket-takeoff me-2" }, null, -1))
const _hoisted_19 = { class: "progress-bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TokenImage = _resolveComponent("TokenImage")!
  const _component_Loader = _resolveComponent("Loader")!

  return ($setup.tempVotes.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h6", _hoisted_6, _toDisplayString(_ctx.$t("meme.vote.pending", $setup.tempVotes.length)), 1),
              _hoisted_7
            ]),
            _createElementVNode("button", {
              class: "btn-close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.voteDiscard && $setup.voteDiscard(...args))),
              disabled: $setup.loading
            }, _hoisted_10, 8, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_11, [
            ($setup.tempNuts > 0n)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("meme.vote.pendingNuts")), 1),
                  _createVNode(_component_TokenImage, {
                    token: $setup.NUTS_TOKEN,
                    amount: $setup.tempNuts,
                    "text-class": "nuts-amount"
                  }, null, 8, ["token", "amount"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, null, 512),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                class: "btn-submit",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.voteSubmit && $setup.voteSubmit(...args))),
                disabled: $setup.loading
              }, [
                _createVNode(_component_Loader, { loading: $setup.loading }, null, 8, ["loading"]),
                (!$setup.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                      _hoisted_18,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("meme.vote.submit")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_16)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", {
              class: "progress-fill",
              style: _normalizeStyle({ width: `${($setup.tempVotes.length / 20) * 100}%` })
            }, null, 4)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}